<div class="chart-container">
    <canvas  id="MyChart" >{{ chart }}</canvas>
</div>